import React, { useEffect } from "react";
import design from "../../Content/Image/icon-design.svg";
import dev from "../../Content/Image/icon-dev.svg";
import photo from "../../Content/Image/icon-photo.svg";

export default function AboutMe() {
  return (
    <div>
      <div className="main-articles ">
        <div className="col-12">
          <h2 className="fw-9 title title--h1 first-title title__separate mb-5">
            درباره‌ی من
          </h2>
          <div className="col-12 p-3 ">
            <p>
              من برنامه‌نویسی‌ رو نه فقط به‌عنوان شغل، بلکه به‌عنوان یه مسیر رشد
              و خلاقیت می‌بینم! از سال ۹۸ وارد دنیای فرانت‌اند شدم و هنوزم با
              اشتیاق در حال یادگیری و خلقم.
<br/>
               در طی این سال‌ها، در پروژه‌های مهمی
              مثل تست‌شو و پروژه‌های وابسته به شهرداری کرج همکاری داشته‌ام و
              تجربه کار در تیم‌های حرفه‌ای را کسب کرده‌ام. حوزه‌ی اصلی من React
              است و در زمینه طراحی رابط‌های کاربرپسند، بهینه و قابل توسعه، تجربه
              گسترده‌ای دارم. در کنار تخصص فنی، در حال حاضر دانشجوی کارشناسی
              ارشد هوش مصنوعی هستم و همواره در مسیر یادگیری و رشد فردی قدم
              برمی‌دارم.
              <br/>

               فردی پرتلاش، قابل اعتماد و علاقه‌مند به کار تیمی هستم و
              به‌طور مداوم در جست‌وجوی بهترین راه‌حل‌ها برای مسائل پیچیده‌ام.
              تواناییم در مدیریت بحران، حل مسئله و خلاقیت باعث شده بتوانم در
              شرایط مختلف عملکرد مؤثری داشته باشم.
              <br/>

               در حال حاضر به‌دنبال یک چالش
              جدید در حوزه تخصصی خود هستم؛ جایی که بتوانم مهارت‌هایم را ارتقا
              دهم و در کنار یک تیم حرفه‌ای رشد کنم.
              <br/>

               بهتر شدن، انتخاب هر روز منه.
            </p>
            <div className="d-flex justify-content-center flex-wrap px-3 mt-5">
            <h5 className="fw-9 title title--h1 first-title title__separate mb-5 d-block w-100  ">
تست های شخصیت شناسی من :
          </h5>
              <span className="mx-3">
                <b>ENTJ</b> در MBTI
              </span>
              <span className="mx-3">
                <b>کمالگرا</b> در انیاگرام{" "}
              </span>
              <span className="mx-3">
                <b>DI</b> در DISC{" "}
              </span>
            </div>
            <h5 className="fw-9 title title--h1 first-title title__separate my-5">
              کارهایی که انجام میدهم
            </h5>

            <div className="col-12 ">
              <div className="row">
                <div className="col-12 col-lg-6">
                  <div className="case-item">
                    <img className="case-item__icon" src={design} alt="" />
                    <div>
                      <h6 className="fw-9 text-white ">طراحی وب</h6>
                      <p className="text-small">
                        طراحی، کدنویسی و اجرای صفحات وب با توجه به دانش و دانایی
                        به‌روز ، اصولی و بهینه
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="case-item">
                    <img className="case-item__icon" src={dev} alt="" />
                    <div>
                      <h6 className="fw-9 text-white ">توسعه وب</h6>
                      <p className="text-small">
                        توسعه وب انجام اصلاحات افزودن بخش های جدید با توجه به
                        تکنولوژی مورد استفاده و بهینه سازی{" "}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="case-item">
                    <i
                      className="fa fa-database case-item__icon"
                      aria-hidden="true"
                    ></i>
                    <div>
                      <h6 className="fw-9 text-white ">داده‌کاوی</h6>
                      <p className="text-small">
                        علاقه‌مند به آموزش حرفه‌ای مند به داده‌کاوی و
                        ماشین‌لرنینگ در زمینه های مختلف{" "}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="case-item">
                    <img className="case-item__icon" src={photo} alt="" />
                    <div>
                      <h6 className="fw-9 text-white ">عکاسی و فیلمبرداری</h6>
                      <p className="text-small">
                        آشنا به عکاسی فیلمبرداری مسلط به امور مقدماتی علاقه‌مند
                        به آموزش حرفه‌ای
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
